import { AppComponents } from "../types";

const AppComponentsDefault: AppComponents = {
  dateFormat: "dd MMMM yyyy",
  timeFormat: "h:mm a",
  Container: {
    cssClasses: "container-fluid",
  },
  Map: {
    display: true,
    style: "background-color:#B2D0FE;",
    cssClasses: "col-sx-12 col-sm-9 col-md-9",
    Debug: {
      visible: true,
    },
  },
  SearchAndResults: {
    display: true,
    cssClasses: "col-sx-12 col-sm-3 col-md-3",
    cssClasses_wide: "col-sx-12 col-sm-12 col-md-12",
  },
  FormTopTabs: [],
  Headers: {
    Flight: {
      Direct: {
        display: true,
      },
      Connection: {
        display: true,
      },
      Date: {
        display: true,
      },
    },
    FlightSearchFilter: {
      display: true,
    },
  },
  Images: {
    HeaderLogo: {
      display: false,
      link: "",
      target: "",
    },
    OAGPromoLogo: {
      display: false,
      link: "",
      target: "",
    },
  },
  Tabs: {
    whereWeFly: {
      display: true,
    },
    flightFinder: {
      display: true,
    },
  },
  Inputs: {
    OriginIata: {
      display: true,
    },
    DestinationIata: {
      display: true,
      anywhere: false,
    },
    RequestDate: {
      display: true,
      startingDay: 1, // 0: Sunday, 1: Monday
      initDayOffset: 0,
      init: true,
    },
    RequestTime: {
      display: true,
      format: "full",
      adjustment: 0,
    },
    DateRange: {
      display: false,
    },
    NonStopFlights: {
      display: true,
      value: false,
      checked: false,
      format: "single",
    },
    IncludeConnections: {
      display: true,
    },
    ReturnRequestDate: {
      display: true,
      startingDay: 1, // 0: Sunday, 1: Monday
      initDayOffset: 0,
      init: true,
    },
    ReturnRequestTime: {
      display: true,
      format: "full",
      adjustment: 0,
    },
    CarrierMultiSelect: {
      display: true,
    },
    PreferredAirlineSelect: {
      display: false,
    },
    IncludeCodeShare: {
      display: true,
      format: "single",
      checked: true,
    },
    DateRangeWeekly: {
      display: false,
      weeklyDefault: false,
    },
    RoundTrip: {
      display: false,
      onewayDefault: false,
    },
    TimeFormat: {
      display: false,
    },
  },
  Buttons: {
    DirectSearch: {
      display: true,
      label: "Fetch",
    },
    ClearAll: {
      display: true,
    },
  },
  Windows: {
    ParametersDebug: {
      display: false,
    },
    MapDirectConnectingLegend: {
      display: true,
    },
  },
  SearchPanel: {
    HeaderStrap: {
      display: true,
      translation: "HEADER_FLIGHT_FINDER",
    },
  },
  Print: {
    whereWeFly: {
      display: true,
    },
    flightFinder: {
      display: true,
    },
  },
  Results: {
    format: "mapper",
    gridHeadDateFormat: [],
    copyToClipboard: false,
    whereWeFly: {
      outbound: {
        directs: {
          display: true,
        },
        connections: {
          display: true,
        },
      },
    },
    return: {
      directs: {
        display: true,
      },
      connections: {
        display: true,
      },
    },
    flightFinder: {
      tabs: {
        outbound: {
          directs: {
            display: true,
          },
          connections: {
            display: true,
          },
        },
        returns: {
          directs: {
            display: true,
          },
          connections: {
            display: true,
          },
        },
        oneSubTab: {
          display: true,
        },
      },
      outbound: {
        directs: {
          display: true,
        },
        connections: {
          display: true,
        },
      },
      return: {
        directs: {
          display: true,
        },
        connections: {
          display: true,
        },
      },
      headers: {
        departureTime: {
          display: false,
        },
      },
    },
    showFlightStatusInPopup: false,
    enableAirlineLink: false,
    showFirstClass: true,
    mergeFlightResults: false
  },
  FilterAndSortMenus: {
    airline: true,
    timespan: true,
    via: true,
    stops: true,
    filterWarning: false,
    timesort: true,
    sortDefault: "departureMinuteOfDay",
  },
  Errors: {
    NO_FLIGHTS_FOUND_SUMMARY: "LABEL_NO_FLIGHTS_FOUND",
    NO_FLIGHTS_FOUND_DETAIL: "LABEL_NO_FLIGHTS_FOUND_DETAIL",
    NO_NONSTOP_FLIGHTS_FOUND_SUMMARY: "LABEL_NO_NONSTOP_FLIGHTS_FOUND",
    NO_NONSTOP_FLIGHTS_FOUND_DETAIL: "LABEL_NO_NONSTOP_FLIGHTS_FOUND_DETAIL",
  },
  ShowOAGCopyright: true,
};

export default AppComponentsDefault;
